// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { dividerClasses } from '@mui/material/Divider';
import { rem } from '../../tokens/conversions';
import { spacing } from '../../tokens/spacing';
import { dividerColors } from './dividerColors';
export var Divider = function(mode) {
    var c = dividerColors(mode);
    var override = {
        MuiDivider: {
            styleOverrides: {
                root: _define_property({
                    borderColor: c.default,
                    '&::before, &::after': {
                        borderColor: c.default
                    }
                }, "&.".concat(dividerClasses.withChildren), _define_property({}, "& .".concat(dividerClasses.wrapper), {
                    color: c.text
                })),
                wrapper: {
                    // MUI's default calc(theme.spacing(1) * 1.2) yields 4.8px; Figma specifies
                    // spacing/1 (4px) as the gap between the line and the label.
                    paddingLeft: rem(spacing[1]),
                    paddingRight: rem(spacing[1])
                },
                textAlignLeft: _define_property({}, "&.".concat(dividerClasses.root), {
                    '&::before': {
                        width: 0
                    }
                }),
                textAlignRight: _define_property({}, "&.".concat(dividerClasses.root), {
                    '&::after': {
                        width: 0
                    }
                })
            },
            variants: [
                {
                    // `border` is independent of `variant` (fullWidth/inset/middle) so the two
                    // axes can combine freely, matching Figma's separate border and layout
                    // props. Named as a plain lowercase, string-valued prop (never a literal
                    // boolean) — MUI's Divider forwards unrecognized props onto the DOM root,
                    // and React only warns about that for camelCase names or literal booleans;
                    // a lowercase string-valued prop like this passes through silently, same as
                    // Breadcrumbs' `size` and IconButton's `variant` elsewhere in this package.
                    props: {
                        border: 'soft'
                    },
                    style: {
                        borderColor: c.soft,
                        '&::before, &::after': {
                            borderColor: c.soft
                        }
                    }
                },
                {
                    props: {
                        border: 'heavy'
                    },
                    style: {
                        borderColor: c.heavy,
                        '&::before, &::after': {
                            borderColor: c.heavy
                        }
                    }
                }
            ],
            defaultProps: {
                variant: 'fullWidth',
                textAlign: 'center',
                orientation: 'horizontal'
            }
        }
    };
    return override;
};

//# sourceMappingURL=Divider.js.map